import moment from 'moment';
import get from 'lodash-es/get';

import {
  getFormValues,
  getQuotation,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  MessagesEnum,
  ModelPathEnum,
} from 'app/shared/enums';
import { getBirthdayStringByPesel } from 'app/services/pesel.service';
import { QuotationService } from 'app/services/quotation.service';
import { validateIsUniquePesel } from 'app/validators';
import { getMessageKeyWithSuffix } from 'app/services/validation.service';

const insurantDetails = {
  checkoutInsurantPeselChange() {
    const pesel = get(
      getFormValues(FormsEnum.CheckoutForm),
      FieldsEnum.CheckoutInsurantPesel
    );

    const birthDate = getBirthdayStringByPesel(pesel);
    const currentDate = moment();
    const yearsDiff = currentDate.diff(moment(birthDate), 'years');
    const isAdult = yearsDiff >= 18;

    const isPeselValid = birthDate !== undefined;
    setMessageVisibility({
      key: MessagesEnum.CheckoutInsurantToYoung,
      visible: isPeselValid && !isAdult,
      formName: FormsEnum.CheckoutForm,
    });

    setMessageVisibility({
      formName: FormsEnum.CheckoutForm,
      key: getMessageKeyWithSuffix(
        FieldsEnum.CheckoutInsurantPesel,
        'too_young_owner_pesel'
      ),
      visible: false,
    });

    const isPeselUnique = validateIsUniquePesel({
      value: pesel,
      questionKey: FieldsEnum.CheckoutInsurantPesel,
      formName: FormsEnum.CheckoutForm,
    });

    const isPeselCorrect =
      (isPeselValid && isAdult && isPeselUnique) || pesel === '';

    if (!isPeselCorrect) {
      return;
    }

    const { id } = getQuotation();
    QuotationService.update(id, ModelPathEnum.InsurantPeselNumber, pesel);
  },
};

export default insurantDetails;
